export default __webpack_public_path__ + "static/media/3536 knife block B side.52d814e5.png";